import React from "react";
import PrivateRoute from "common/routes/PrivateRoute/PrivateRoute";

export default function LibrosProtectedRoute(props){
    return <PrivateRoute allowedroles={["libros-contables",'administrator','recepcion']}>
        {props.children}
    </PrivateRoute>;
}